import React from "react";

export const OptimismTestnetIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1105_4080)">
      <path
        d="M9.99876 15.0916V18.8278C6.15551 18.8278 3.03906 15.7113 3.03906 11.8681C3.03906 8.02486 6.15551 4.90841 9.99876 4.90841V1.17212C13.842 1.17212 16.9585 4.28861 16.9585 8.13181C16.9585 11.9751 13.842 15.0916 9.99876 15.0916Z"
        fill="white"
      />
      <path
        d="M10 0C4.47766 0 0 4.47765 0 9.99999C0 15.5223 4.47766 20 10 20C15.5224 20 20 15.5223 20 9.99999C20 4.47765 15.5224 0 10 0ZM10 15.0916V18.8278C6.15676 18.8278 3.04031 15.7113 3.04031 11.8681C3.04031 8.0249 6.15676 4.90845 10 4.90845V1.17216C13.8432 1.17216 16.9597 4.28865 16.9597 8.13185C16.9597 11.9751 13.8432 15.0916 10 15.0916ZM13.4432 9.96774V10.0322C11.9253 10.7883 10.7883 11.9252 10.0323 13.4432H9.96775C9.21171 11.9252 8.07471 10.7883 6.55676 10.0322V9.96774C8.07471 9.2117 9.21171 8.07475 9.96775 6.5568H10.0323C10.7883 8.07475 11.9253 9.2117 13.4432 9.96774Z"
        fill="#FFB300"
      />
    </g>
    <defs>
      <clipPath id="clip0_1105_4080">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
